/* Driveora — theme interactions */
(function () {
  'use strict';

  // − / + buttons on quantity fields (product page and cart)
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-qty-step]');
    if (!button) return;
    var wrapper = button.closest('.qty');
    var input = wrapper ? wrapper.querySelector('input') : null;
    if (!input) return;
    var min = parseInt(input.getAttribute('min') || '0', 10);
    var step = parseInt(button.getAttribute('data-qty-step'), 10);
    var next = (parseInt(input.value, 10) || 0) + step;
    input.value = Math.max(isNaN(min) ? 0 : min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Product gallery thumbnails
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-thumb]');
    if (!thumb) return;
    var root = thumb.closest('[data-product]');
    var image = root ? root.querySelector('[data-gallery-main] img') : null;
    if (!image) return;
    image.removeAttribute('srcset');
    image.src = thumb.getAttribute('data-src');
    image.alt = thumb.getAttribute('data-alt') || '';
    root.querySelectorAll('[data-thumb]').forEach(function (item) {
      var active = item === thumb;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  });

  // Variant change: price, availability, photo and URL
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches('[data-variant-input]')) return;
    var root = input.closest('[data-product]');
    if (!root) return;
    var data = input.dataset;

    var price = root.querySelector('[data-price]');
    if (price) price.textContent = data.price;

    var compare = root.querySelector('[data-compare]');
    if (compare) {
      compare.textContent = data.compare || '';
      compare.hidden = !data.compare;
    }

    var discount = root.querySelector('[data-discount]');
    if (discount) {
      discount.textContent = data.discount ? '−' + data.discount + ' %' : '';
      discount.hidden = !data.discount;
    }

    var title = root.querySelector('[data-variant-title]');
    if (title) title.textContent = data.title;

    var button = root.querySelector('[data-add-button]');
    if (button) {
      var available = data.available === 'true';
      button.disabled = !available;
      button.textContent = available ? button.dataset.labelAdd : button.dataset.labelSoldOut;
    }

    if (data.mediaSrc) {
      var image = root.querySelector('[data-gallery-main] img');
      if (image) {
        image.removeAttribute('srcset');
        image.src = data.mediaSrc;
      }
    }

    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', input.value);
      window.history.replaceState({}, '', url.toString());
    } catch (error) { /* older browser: ignore */ }
  });

  // Collection sorting
  document.addEventListener('change', function (event) {
    var select = event.target;
    if (select.matches && select.matches('[data-auto-submit]') && select.form) select.form.submit();
  });

  // Product recommendations (loaded after the page)
  function loadRecommendations(scope) {
    (scope || document).querySelectorAll('[data-recommendations]').forEach(function (element) {
      var url = element.getAttribute('data-url');
      if (!url) return;
      fetch(url)
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim()) element.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    });
  }
  loadRecommendations();
  document.addEventListener('shopify:section:load', function (event) { loadRecommendations(event.target); });

  // Mobile menu: close with Escape
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-menu-drawer][open]').forEach(function (drawer) {
      drawer.removeAttribute('open');
      var summary = drawer.querySelector('summary');
      if (summary) summary.focus();
    });
  });
})();
